/*
 * ALOHA — Pastilles de couleur sur les cartes produit.
 *
 * Avant : un clic sur une pastille envoyait directement sur la fiche
 * produit. On quittait la collection pour voir une couleur.
 *
 * Maintenant : le clic change l'image de la carte sur place, et met a
 * jour le lien de la carte vers cette variante — pour que la cliente
 * qui clique ensuite sur la photo arrive sur la bonne couleur, et non
 * sur la variante par defaut.
 *
 * Repli : si la variante n'a pas d'image, ou si quoi que ce soit
 * echoue, on retombe sur l'ancien comportement (navigation). Le clic
 * ne peut donc jamais rester sans effet.
 */

class ProductCardSwatches extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.addEventListener('keydown', this.#onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('keydown', this.#onKeydown);
  }

  #onKeydown = (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const swatch = e.target.closest('[data-href]');
    if (!swatch) return;
    e.preventDefault();
    this.#activer(swatch);
  };

  #onClick = (e) => {
    const swatch = e.target.closest('[data-href]');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    this.#activer(swatch);
  };

  #activer(swatch) {
    const url = swatch.dataset.href;

    try {
      const image = swatch.dataset.variantImage;
      const carte = this.closest('.product-card') || this.closest('[data-product-url]');

      // Pas d'image de variante, ou pas de carte identifiable :
      // on garde l'ancien comportement.
      if (!image || !carte) {
        if (url) window.location.href = url;
        return;
      }

      const cible = carte.querySelector('img');
      if (!cible) {
        if (url) window.location.href = url;
        return;
      }

      // Echange de l'image affichee.
      cible.removeAttribute('sizes');
      cible.srcset = swatch.dataset.variantSrcset || '';
      cible.src = image;
      if (swatch.dataset.variantAlt) cible.alt = swatch.dataset.variantAlt;
      cible.removeAttribute('loading');

      // La carte pointe desormais vers cette variante.
      if (url) {
        carte.dataset.productUrl = url;
        carte.querySelectorAll('a[href]').forEach((lien) => {
          if (lien.closest('product-card-swatches')) return;
          lien.href = url;
        });
        if (carte.tagName === 'A') carte.href = url;
      }

      // Etat visuel de la pastille choisie.
      this.querySelectorAll('[data-href]').forEach((s) => {
        s.removeAttribute('aria-checked');
        s.classList.remove('swatch--active');
      });
      swatch.setAttribute('aria-checked', 'true');
      swatch.classList.add('swatch--active');
    } catch (err) {
      // Toute erreur ramene au comportement d'origine.
      if (url) window.location.href = url;
    }
  }
}

if (!customElements.get('product-card-swatches')) {
  customElements.define('product-card-swatches', ProductCardSwatches);
}
